module.exports = __webpack_public_path__ + "static/media/file-text.09f0201e.svg";